import { useCallback, useEffect, useMemo, useState } from 'react';
import { createContextForController } from 'react-controller-context';
import { useGradeLevels } from './use-grade-levels';
import { useStudents } from './use-students';
import { useGradYearState } from './use-grad-year-state';
import { useSelectedStudents } from './use-selected-students';

export const useController = () => {
    const {
        selectedStudents,
        addStudents,
        removeStudents
    } = useSelectedStudents();
    const { students } = useStudents();
    const {
        gradYears,
        getGradYearLabel,
    } = useGradeLevels();


    const isGradYearSelected = useCallback(
        gradYear => {
            const gradYearStudents = students.filter(s => s.gradYear === gradYear);
            const gradYearSelectedStudents = selectedStudents.filter(s => s.gradYear === gradYear);
            return gradYearStudents.length === gradYearSelectedStudents.length;
        }, 
        [selectedStudents]
    );

    const setGradYearSelected = useCallback(
        (gradYear, selected) => {
            const gradYearStudents = students.filter(s => s.gradYear === gradYear);
            if (selected) {
                addStudents(gradYearStudents);
            } else {
                removeStudents(gradYearStudents);
            }
        },
        [students, addStudents, removeStudents]
    );

    const canAlterGradYearSelection = useCallback(gradYear => {
        const gradYearStudents = students.filter(s => s.gradYear === gradYear);
        return gradYearStudents.length > 0;
    }, [students]);

    const selectAll = useCallback(() => {
        addStudents(students);
    }, [students, addStudents]);

    const deselectAll = useCallback(() => {
        removeStudents(students);
    }, [students, removeStudents]);


    return {
        gradYears,
        getGradYearLabel,
        isGradYearSelected,
        setGradYearSelected,
        canAlterGradYearSelection,
        selectAll,
        deselectAll
    };
};

const context = createContextForController(useController);
export const GradYearSelectabilityProvider = context.Provider;
export const useGradYearSelectability = context.useController;